/* eslint-disable no-case-declarations */
import { api as $axios } from '@/helpers/interceptors'
import * as path from '@/constants/path'
import snakeCaseKeys from 'snakecase-keys'
import { meta } from '@/config/pagination'
import dayjs from 'dayjs'
const {
  GET_ORDER_LIST,
  // GET_ORDER_LIST_V
} = path
import i18n from '../plugins/i18n'
import { numberFormat } from '@/utils/utils'

const initFilter = {
  name: null,
  email: null,
  phone: null,
  refId: null,
  productSku: null,
  payload: null,
  status: '',
  type: 'All',
  campaignId: 'All',
  orderCreate: [
    dayjs().startOf('month').format('YYYY-MM-DD'),
    dayjs().endOf('month').format('YYYY-MM-DD'),
  ],
  loadingDownloadFile: false,
}

export const freezeReport = [
  {
    label: i18n.t('label.all'),
    key: 'total',
    data: 0,
    amount: 0,
    color: 'black',
  },
  {
    label: i18n.t('label.orderInprogress'),
    key: 'create',
    data: 0,
    amount: 0,
    color: 'warning',
    icon: 'mdi-cart-outline',
  },
  {
    label: i18n.t('label.cancel'),
    key: 'return',
    data: 0,
    amount: 0,
    color: 'red',
    icon: 'mdi-cancel',
  },
  {
    label: i18n.t('label.complete'),
    key: 'complete',
    data: 0,
    amount: 0,
    color: 'success',
    icon: 'mdi-check-circle-outline',
  },
  {
    label: i18n.t('label.depositOrder'),
    key: 'depositOrder',
    data: 0,
    amount: 0,
    color: 'black',
  },
  {
    label: i18n.t('label.fullOrder'),
    key: 'fullOrder',
    data: 0,
    amount: 0,
    color: 'black',
  },
]

export const cleanQuery = (queries) => {
  let query = JSON.parse(JSON.stringify(queries))
  query.campaignId = query.campaignId?.id ?? 'All'

  query.campaignId === 'All' || !query.campaignId === undefined
    ? delete query.campaignId
    : null

  query.status === 'All' || !query.status === undefined
    ? delete query.status
    : null

  query.type === 'All' || !query.type === undefined
    ? delete query.type
    : null
  query.orderCreateEnd = query.orderCreate[1]

  query.orderCreate = query.orderCreate[0]
  return query
}

const state = () => ({
  data: [],
  report: Array.from(freezeReport),
  orderDetail: null,
  filter: initFilter,
  searchText: null,
  meta: meta,
  isError: false,
  isLoading: false,
})

// getters
const getters = {}

// actions
const actions = {
  async getOrders({ commit }, params) {
    try {
      delete params.refresh
      params.orderCreateEnd = params.orderCreate[1]
      params.orderCreate = params.orderCreate[0]

      commit('SET_LOADING', true)
      const res = await $axios(
        `${GET_ORDER_LIST}`,
        'get',
        snakeCaseKeys({ params }),
      )

      commit('SET_STATE', {
        key: `data`,
        value: res.data?.data,
        // value: res.data?.data?.orders?.data,
      })

      //   commit('SET_REPORT', res.data?.data?.report)

      commit('SET_STATE', { key: 'meta', value: res?.data?.meta })
      commit('SET_LOADING', false)
    } catch (e) {
      commit('SET_LOADING', false)
      return new Error(e)
    }
  },

  async getOrderDetail({ commit }, orderId) {
    try {
      commit('SET_LOADING', true)
      let res = null
      if (orderId) {
        res = await $axios(`${GET_ORDER_LIST}/${orderId}`, 'get')
      }
      commit('SET_STATE', {
        key: `orderDetail`,
        value: {
          ...res.data?.data,
          child: res.data?.data?.bundleProducts,
        },
      })
      commit('SET_LOADING', false)
    } catch (e) {
      commit('SET_LOADING', false)
      return new Error(e)
    }
  },

  async cancelOrder({ commit }, orderId) {
    try {
      commit('SET_LOADING', true)
      if (orderId) {
        await $axios(`${GET_ORDER_LIST}/${orderId}`, 'put', {
          status: 'cancel',
        })
      }
      commit('SET_LOADING', false)
    } catch (e) {
      commit('SET_LOADING', false)
      return new Error(e)
    }
  },
  async download({ commit }, query) {
    try {
      commit('SET_STATE', { key: 'loadingDownloadFile', value: true })
      let params = cleanQuery(query)
      await $axios(
        `${GET_ORDER_LIST}/export`,
        'get',
        snakeCaseKeys({ params }),
      ).then((response) => {
        const blob = new Blob([response.data], {
          type: 'text/csv;charset=utf-8',
        })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = `รายการสั่งซื้อของวันที่_${params.orderCreate}`
        link.click()
        URL.revokeObjectURL(link.href)
      })
      commit('SET_STATE', {
        key: 'loadingDownloadFile',
        value: false,
      })
    } catch (e) {
      commit('SET_STATE', {
        key: 'loadingDownloadFile',
        value: false,
      })
      return new Error(e)
    }
  },
  async orderCompletely({ commit }, orderId) {
    try {
      commit('SET_LOADING', true)
      if (orderId) {
        await $axios(`${GET_ORDER_LIST}/${orderId}`, 'put', {
          status: 'complete',
        })
      }
      commit('SET_LOADING', false)
    } catch (e) {
      commit('SET_LOADING', false)
      return new Error(e)
    }
  },

  setSearchText({ commit }, message) {
    commit('SET_STATE', {
      key: 'searchText',
      value: message,
    })
  },

  setFilter({ commit }, message) {
    commit('SET_STATE', {
      key: 'filter',
      value: message,
    })
  },

  setPayload({ commit }, payload) {
    commit('SET_STATE', {
      key: 'payload',
      value: payload,
    })
  },
}

// mutations
const mutations = {
  SET_STATE(state, ops) {
    state[ops.key] = ops.value
  },
  SET_LOADING(state, payload) {
    state.isLoading = payload
  },
  SET_STATE_BY_KEY(state, ops) {
    state[ops.key][ops.childKey] = ops.value
  },

  SET_REPORT(state, value) {
    state.report[0].data = numberFormat(value.total)
    state.report[1].data = numberFormat(value.created)
    state.report[2].data = numberFormat(value.return)
    state.report[3].data = numberFormat(value.complete)
    state.report[4].data = numberFormat(value.depositOrder)
    state.report[4].amount = numberFormat(value.depositAmount) ?? 0

    state.report[5].data = numberFormat(value.fullOrder)
    state.report[5].amount = numberFormat(value.fullAmount) ?? 0
  },
  CLEAR_REPORT(state) {
    for (const item of freezeReport) {
      item.data = 0
      item.amount = 0
    }
    state.report = freezeReport
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
